const { Popover, MenuList, MenuItem, IconButton, ListItemIcon, ListItemText } = window.Material;
const { MoreHoriz, Folder } = MaterialIcons;

export default class Dropdown extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      anchor: null,
    };
  }

  handleDropDownClick = event => {
    this.setState({ anchor: event.currentTarget });
  };

  closeMenu = () => {
    this.setState(() => ({ anchor: null }));
  };

  onFolderClick = item => {
    const { onClick } = this.props;

    onClick(item);

    this.closeMenu();
  };

  render() {
    const { folders } = this.props;
    const { loadingContent } = this.context;

    return (
      <div className="Top-Level-Buttons-Wrap--Dropdown">
        <IconButton onClick={this.handleDropDownClick} id="breadcrumbsDropdownBtn" disabled={loadingContent}>
          <MoreHoriz fontSize="small" />
        </IconButton>
        <Popover
          open={this.state.anchor !== null}
          anchorEl={this.state.anchor}
          onClose={this.closeMenu}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
        >
          <MenuList>
            {folders.map((item, index) => (
              <MenuItem key={index} onClick={() => this.onFolderClick(item)} id={`breadcrumbs${index + 1}`}>
                <ListItemIcon>
                  <Folder />
                </ListItemIcon>
                <ListItemText primary={item.name} />
              </MenuItem>
            ))}
          </MenuList>
        </Popover>
      </div>
    );
  }
}
